import { ENG, CH } from "../../constants"

let dictionary = {}

dictionary[ENG] = {
    NAME: "WEI FAN CHANG",
    SLOGAN: "I am a software engineer."
}

dictionary[CH] = {
    NAME: "張葳凡",
    SLOGAN: "我是軟體工程師哦"
}

export default dictionary
